import {gql, useMutation} from "@apollo/client";

const REMOVE_EVENT_MUTATION = gql`
mutation DeleteEvent($eventId: ID!) {
  deleteEvent(eventId: $eventId) {
    success    
  }
}


`;

export default function RemoveEventMutation() {
    return useMutation(REMOVE_EVENT_MUTATION);
}